export default __webpack_public_path__ + "static/retirement-planning-1-852843b69b1c7d65e1b89ec9951d5988.png";